export default __webpack_public_path__ + "static/media/firebirds.6ee45cf8.svg";